import { Col, Form, Input, notification } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { useContatosContext } from '../../../../../contexts/ContatosContexto';
import { validateEmailFormat } from '../../../../../helpers/validators';
import { getColumns } from './columns';
import { AddButton, FormInputButton, Table } from './styles';

export default function FormAddContato({ form }) {
  const {
    contatos,
    removeContatoAction,
    addContatoAction,
  } = useContatosContext();

  const handleAdicionarContato = () => {
    const data = {
      contato: form.getFieldValue('email'),
    };

    if (data.contato !== null) {
      addContatoAction(data.contato);

      form.setFieldsValue({
        email: null,
      });
    }
  };

  const handleDeletarContato = contatoRemovido => {
    try {
      removeContatoAction(contatoRemovido);

      notification.success({
        message: 'Remover E-mail',
        description: 'Este e-mail foi removido com sucesso.',
      });
    } catch (error) {
      notification.error({
        message: 'Ops, não foi possível remover o e-mail',
        description:
          'Por favor, entre em contato com nosso suporte caso o problema persistir.',
      });
    }
  };

  const handleValidateEmail = async value => {
    if (value !== null && value !== undefined && validateEmailFormat(value)) {
      return Promise.resolve();
    }
    return Promise.reject();
  };

  const columnsTable = getColumns(handleDeletarContato);

  return (
    <>
      <FormInputButton>
        <Col span={20}>
          <Form.Item
            name="email"
            label=""
            rules={[
              {
                required: false,
                message: 'Por favor, insira um e-mail válido!',
                validator: (_, value) => handleValidateEmail(value),
              },
            ]}
          >
            <Input
              placeholder="Digite o e-mail"
              className="total-width"
              maxLength={100}
            />
          </Form.Item>
        </Col>

        <Col>
          <AddButton
            type="primary"
            aria-label="adicionarContatoButton"
            onClick={handleAdicionarContato}
          >
            Adicionar
          </AddButton>
        </Col>

        <Col span={24}>
          <Table
            dataSource={contatos}
            columns={columnsTable}
            pagination={false}
            rowKey="index"
          />
        </Col>
      </FormInputButton>
    </>
  );
}

FormAddContato.propTypes = {
  form: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  ).isRequired,
};
